import type { WritableComputedRef } from 'vue'
import type { EmitWithUpdate, PropsWithValue } from './types'

import { computed } from 'vue'

/**
 * A helper function to create a reactive model value.
 * @param props The props of the component.
 * @param emit The emit function that is already defined with the defineEmits macro.
 * @param key The key of the model value, you can override it if you want to name your prop something other than modelValue.
 * @returns A writable computed ref that can now get repackaged into v-model.
 */
export default function useModelValue<K extends string, T, P>(
  props: PropsWithValue<P, K, T>,
  emit: EmitWithUpdate<K, T>,
  key = 'modelValue' as K
): WritableComputedRef<T> {
  return computed({
    get: () => props[key],
    set: (value: T) => emit(`update:${key}`, value),
  })
}
